// TODO: Revert to 14 september 2026 after testing
export const timeToStart = "2026-09-24 00:01:00";
export const timeToEnd = "2026-09-29 18:00:00";
